import React from 'react';
import dynamic from 'next/dynamic';
import Skeleton from '@mui/material/Skeleton';
import { createRetryableImport } from '@/utils/chunk-error-handler';

export const CusEcharts = dynamic(
  createRetryableImport(() => import('@/components/CusEcharts')),
  {
    ssr: true,
    loading: () => (
      <div className="w-full h-full flex justify-center items-center">
        <div className="animate-spin w-10 h-10 rounded-full border border-2 border-web-blue-500/20 border-t-web-blue-500" />
      </div>
    ),
  },
);

export const Liquid = dynamic(
  createRetryableImport(() => import('@/components/Liquid')),
  {
    ssr: true,
    loading: () => (
      <Skeleton variant="circular" className="w-12 h-12 inline-block" />
    ),
  },
);

export const RichText = dynamic(
  createRetryableImport(() => import('@/components/form/rich-text/RichText')),
  {
    loading: () => (
      <div className="animate-pulse">
        <Skeleton
          variant="rounded"
          className="mb-9.5"
          width="100%"
          height={52}
        />
        <Skeleton variant="rounded" width="100%" height={160} />
      </div>
    ),
    ssr: false,
  },
);
